import {get as _get, cloneDeep as _cloneDeep} from 'lodash';
import initialState from '../initialstate';
import {
	FILTER_CONTACTS,
	UPDATE_DISPLAY_DATA,
	UPDATE_TREE_ORG,
	SET_USER_COLUMNS,
	SET_CONTACT_SELECTED,
	SELECT_CONTACT,
	CLEAR_CONTACTSDB_FILTER,
	RESET_BULK_SELECTION,
	SET_TAGS
} from '../../actions/actiontypes';
import {mapEntities, sortEntities} from './normalizeContactList';
import normalizeFilters from './normalizeFilters';
import filterEntities from './filterEntities';
import {HttpStatusCodes, entityParamFromUrl} from '../../util/uiconstants';

//TODO: remove all the cloneDeep.
export function contactDBReducer(state = initialState.contacts, action) {
	switch (action.type) {
		case UPDATE_DISPLAY_DATA:
		case UPDATE_TREE_ORG:
		case FILTER_CONTACTS:
		case CLEAR_CONTACTSDB_FILTER: {
			let entities = _cloneDeep(_get(action, 'entities', _get(state, 'entities', null)));
			const orgChart = _cloneDeep(_get(action, 'treeOrgChart', _get(state, 'orgChart', null)));

			const {filterData = null} = action;
			const maintainSelected = _get(action, 'maintainSelected', false);
			const selected = maintainSelected ? [...state.selected] : [];
			if (entities && !orgChart) return {...state, entities, orgChart};
			const sortedEntities = sortEntities(entities, orgChart);
			let normalizedFilters = normalizeFilters(state.filters, filterData);
			if (action.type === CLEAR_CONTACTSDB_FILTER) normalizedFilters = {};
			return {
				...state,
				orgChart,
				entities: sortedEntities,
				selected,
				displayedEntities: filterEntities(normalizedFilters, sortedEntities.map(mapEntities)),
				filters: normalizedFilters
			};
		}

		case SELECT_CONTACT: {
			const {contactId = null} = action;
			return {...state, selected: [...new Set([...contactId])]};
		}

		case RESET_BULK_SELECTION: {
			return {...state, selected: []};
		}

		case SET_USER_COLUMNS: {
			const columns = _get(action, 'data', null);

			//this is for avoiding the state mutation
			const customizeColumns = columns.map((c) => JSON.parse(JSON.stringify(c)));
			return {...state, customizeColumns};
		}
		case SET_CONTACT_SELECTED: {
			const previusSelected = {contactSelected: action.data};
			return {...state, ...previusSelected};
		}

		default: {
			return state;
		}
	}
}
